import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		data: {
			menu: ['About', 'Experience', 'Education', 'Skills', 'Interests', 'Portfolio'],
			nama_depan: 'Danang',
			nama_belakang: 'Dismantoro',
			title: 'S.Kom., M.T.',
			alamat: 'Ponorogo - East Java - Indonesia',
			hp: '0811 8111 426',
			email: 'danang@fahiltek.co.id',
			experience: 'I am experienced in leveraging agile frameworks to provide a robust synopsis for high level overviews. Iterative approaches to corporate strategy foster collaborative thinking to further the overall value proposition.',
			medsos: [
				{
					link: 'https://linkedin.com/in/danang-dismantoro-skom-mt',
					fa_icon: 'fab fa-linkedin-in'
				},
				{
					link: 'https://github.com/danangponorogo',
					fa_icon: 'fab fa-github'
				},
				{
					link: 'https://gitlab.com/danang.dandies',
					fa_icon: 'fab fa-gitlab'
				},
				{
					link: 'https://api.whatsapp.com/send?phone=+628118111426',
					fa_icon: 'fab fa-whatsapp'
				},
				{
					link: 'https://t.me/danangponorogo',
					fa_icon: 'fab fa-telegram'
				},
				{
					link: 'mailto:danang@fahiltek.co.id',
					fa_icon: 'fas fa-envelope'
				},
				{
					link: 'https://www.facebook.com/danang.dandies',
					fa_icon: 'fab fa-facebook-f'
				}
			],
			pengalaman: [
				{
					posisi: 'Senior Web Developer',
					perusahaan: 'Fahil Teknologi',
					deskripsi: 'Bring to the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, a new normal that has evolved from generation X is on the runway heading towards a streamlined cloud solution. User generated content in real-time will have multiple touchpoints for offshoring.',
					periode: 'July 2018 - Present'
				},
				{
					posisi: 'IT Staf (ASN)',
					perusahaan: 'Bagian Adm. Pembangunan Setda Kabupaten Ponorogo',
					deskripsi: 'Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs from DevOps. Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.',
					periode: 'September 2009 - Present'
				},
				{
					posisi: 'Freelance Web Developer',
					perusahaan: 'Freelancer',
					deskripsi: 'Podcasting operational change management inside of workflows to establish a framework. Taking seamless key performance indicators offline to maximise the long tail. Keeping your eye on the ball while performing a deep dive on the start-up mentality to derive convergence on cross-platform integration.',
					periode: 'July 2010 - June 2018'
				},
				{
					posisi: 'Junior Web Developer',
					perusahaan: 'Promedia International',
					deskripsi: 'Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. Dramatically visualize customer directed convergence without revolutionary ROI.',
					periode: 'September 2008 - June 2010'
				}

			],
			pendidikan: [
				{
					institusi: 'Institut Teknologi Sepuluh Nopember Surabaya',
					gelar: 'Master Techniques',
					prodi: 'Telematics',
					ipk: '3.68',
					periode: 'August 2018 - August 2020'
				},
				{
					institusi: 'Universitas Dinamika (Stikom Surabaya)',
					gelar: 'Bachelor of Computer',
					prodi: 'Computer Engineering',
					ipk: '3.21',
					periode: 'August 1999 - August 2006'
				}

			],
			skills: ['fab fa-git', 'fab fa-html5', 'fab fa-css3-alt', 'fab fa-js-square', 'fab fa-vuejs', 'fab fa-react', 'fab fa-node-js', 'fab fa-laravel', 'fab fa-wordpress', 'fab fa-gulp', 'fab fa-bootstrap', 'fab fa-npm', 'fab fa-php'],
			workflow: [
				'Mobile-First, Responsive Design',
				'Cross Browser Testing & Debugging',
				'Cross Functional Teams',
				'Agile Development'
			],
			interests: [
				'Apart from being a web developer, I enjoy most of my time being outdoors. In the winter, I am an avid skier and novice ice climber. During the warmer months here in Colorado, I enjoy mountain biking, free climbing, and kayaking.',
				'When forced indoors, I follow a number of sci-fi and fantasy genre movies and television shows, I am an aspiring chef, and I spend a large amount of my free time exploring the latest technology advancements in the front-end web development world.'
			],
			portfolio: [
				{
					link: 'http://sidakbaja.sulbarprov.go.id',
					nama: 'Aplikasi Sidak Baja UKPBJ Provinsi Sulawesi Barat',
					tahun: 2020
				},
				{
					link: 'https://e-rekom.iusp.ponorogo.go.id',
					nama: 'Aplikasi e-Rekom IUSP Dinas Perdakum Kabupaten Ponorogo',
					tahun: 2020
				},
				{
					link: 'https://baktipertiwi.co.id',
					nama: 'Website CV. Bakti Pertiwi Kabupaten Ponorogo',
					tahun: 2019
				},
				{
					link: 'https://simsurat.fahiltek.co.id/',
					nama: 'Aplikasi SIMSURAT Sekretariat DPRD Kabupaten Ponorogo',
					tahun: 2019
				},
				{
					link: 'https://simars.ponorogo.go.id/',
					nama: 'Aplikasi SIMARS Bagian Umum Setda Kabupaten Ponorogo',
					tahun: 2018
				},
				{
					link: 'https://kabponorogo.jdih.jatimprov.go.id/',
					nama: 'Website Bagian Hukum Setda Kabupaten Ponorogo',
					tahun: 2017
				},
				{
					link: 'https://lpse.web.id/simap',
					nama: 'Aplikasi SIMAP Dinas Perpustakaan dan Kearsipan Kabupaten Ponorogo',
					tahun: 2016
				},
				{
					link: 'https://simres.fahiltek.co.id/',
					nama: 'Aplikasi SIMRES Bagian Umum Setda Kabupaten Ponorogo',
					tahun: 2015
				},
			]
		}
	}
});

export default app;